export default "{\n    \"getPaidOn\": \"Se paga el {{date}}\"\n}\n"